/**
 * Copyright 2026 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

import { useGetGroupUniqueAttributesQuery } from "~/generated/graphql";
import { showError } from "~/services/toast";

export function useGetGroupUniqueAttributes() {
  const {
    data: result,
    loading,
    error,
  } = useGetGroupUniqueAttributesQuery({
    onError(err) {
      showError(err.message);
    },
  });

  const data = result?.groupUniqueAttributes;

  return { data, loading, error } as const;
}
